import { BaseLayoutFactory } from '../global/base-layout-factory';
import { BiddingDetailProvider } from './context/bidding-detail-context';
import { BiddingDetailComponent } from './bidding-detail-component';

export function BiddingDetailFactory() {
    return (
        <BaseLayoutFactory>
            <BiddingDetailProvider>
                <BiddingDetailComponent />
            </BiddingDetailProvider>
        </BaseLayoutFactory>
    );
}
